import { EXPORT_S3, GET_S3_IMAGE } from "../api";
import axiosInstance from "../axiosInstance";

export const exports3 = (props) => (onResponse) => {
  try {
    axiosInstance
      .post(EXPORT_S3, props)
      .then((response) => {
        // console.log(response)
        onResponse(response.data);
      })
      .catch((err) => {
        console.log(err);
        onResponse(err.response?.data);
      });
  } catch (error) {}
};

export const gets3Image = (props) => (onResponse) => {
  try {
    let BASE_URL = GET_S3_IMAGE + "?";
    if (props?.page) {
      BASE_URL += "page=" + props?.page + "&";
    }

    if (props?.folder_name) {
      BASE_URL += "folder_name=" + props?.folder_name + "&";
    }

    if (props?.museum) {
      BASE_URL += "museum=" + props?.museum + "&";
    }
    if (props?.image_type) {
      BASE_URL += "image_type=" + props?.image_type + "&";
    }

    axiosInstance
      .get(BASE_URL)
      .then((response) => {
        onResponse(response?.data);
      })
      .catch((err) => {
        onResponse(err.response?.data);
      });
  } catch (err) {
    console.log(err);
  }
};
